/**
 * @ngdoc object
 * @name billing.invoice_templates
 * @description
 *
 */
angular
    .module('festzelt-os.billing.invoice_templates', [
        'ui.router',
        //'ngListView'
    ]);

require('./invoice_templates-routes');

// Controllers
require('./controllers/create-controller');
require('./controllers/edit-controller');
require('./controllers/list-controller');

// Factories
require('./factories/invoice_template-factory');

// Store
require('./store/invoices_templates');



// WEBPACK FOOTER //
// ./src/app/pages/billing/invoice_templates/invoice_templates-module.js